<template>
    <az-container>
        <az-form>
            <div class="plano-faturas-header">
                <div class="plano-faturas-info">
                    <div class="info-container">
                        <label class="label-plano-faturas">Informações do Plano</label>
                        <label class="label-info-content" v-if="assinaturaAtual">{{assinaturaAtual.planoProduto.nome}}:
                            <span class="bold-content">{{assinaturaAtual.valor | valorParaReal}} ({{assinaturaAtual.ciclo | azEnum(tiposCiclosPlanoAssinatura)}})</span>
                            <span class="bold-content" v-if="assinaturaStatus"> - {{ assinaturaStatus }}</span>
                        </label>
                        <label class="label-info-content" v-else>Nenhuma assinatura encontrada</label>
                    </div>
                    <div>
                        <v-btn
                                class="btn-alterar-plano-faturas"
                                depressed
                                outline
                                @click="alterarPlano">
                            Alterar Plano
                        </v-btn>
                    </div>
                </div>
                <div class="plano-faturas-cadastro">
                    <label class="label-plano-faturas">Cadastro</label>
                    <label class="label-cadastro-content">
                        {{$store.state.loki.user.domainId ? 'Aprovado' : 'Não Homologado'}}
                    </label>
                </div>
            </div>
            <div class="li-tabela historico-plano-faturas">
                <label class="label-plano-faturas" style="margin: 10px">Histórico de Faturas</label>
                <plano-faturas-tabela
                        :itens="itens" :paginas="paginas" :total-itens="totalItens"
                        :paginacao="$store.state.planoFaturas.paginacao"
                        @paginar="eventoPaginar"
                        @pagar="eventoPagar"
                />
            </div>
        </az-form>
    </az-container>
</template>

<script>
    import {mapActions, mapMutations} from 'vuex'
    import moment from 'moment'
    import {actionTypes, mutationTypes, tiposCiclosPlanoAssinatura} from '@/commons/constants'
    import PlanoFaturasTabela from './PlanoFaturasTabela'

    export default {
        name: 'PlanoFaturas',
        components: {PlanoFaturasTabela},
        data() {
            return {
                tiposCiclosPlanoAssinatura,
                itens: [],
                paginas: 0,
                totalItens: 0,
                assinaturaAtual: null,
                assinaturaStatus: null
            }
        },
        async mounted() {
            this.verificarUsuarioFornecedor()
            await this.buscarAssinaturaAtual()
            await this.buscarCobrancas()
        },
        methods: {
            ...mapActions([
                actionTypes.BUSCAR_DADOS_ASSINATURAS_FORNECEDOR,
                actionTypes.BUSCAR_COBRANCAS_FORNECEDOR,
            ]),
            ...mapMutations([
                mutationTypes.SET_PAGINACAO_BUSCA_COBRANCAS_FORNECEDOR
            ]),
            async buscarAssinaturaAtual() {
                const {assinaturaAtual, ultimaAssinaturaExpirada, assinaturaPendente} = await this.buscarDadosAssinaturasFornecedor()
                if (assinaturaAtual) {
                    this.assinaturaAtual = assinaturaAtual
                    if (assinaturaAtual.situacao === 'ACESSO_TEMPORARIO'){
                        this.assinaturaStatus = 'Acesso temporário até a data: ' + moment(assinaturaAtual.dataVencimentoAcessoTemporario).add(1, 'hours').format('DD/MM/YYYY')
                    }
                } else if (assinaturaPendente) {
                    this.assinaturaAtual = assinaturaPendente
                    this.assinaturaStatus = 'Pendente de pagamento'
                } else if (ultimaAssinaturaExpirada) {
                    this.assinaturaAtual = ultimaAssinaturaExpirada
                    this.assinaturaStatus = 'Expirado'
                } else {
                    this.assinaturaAtual = null
                }
            },
            async buscarCobrancas() {
                this.setMensagemLoading('Carregando Cobranças...')
                const resultado = await this.buscarCobrancasFornecedor()
                if (resultado.totalElements) {
                    this.itens = resultado.items
                    this.paginas = resultado.totalPages
                    this.totalItens = resultado.totalElements
                }
            },
            eventoPaginar(paginacao) {
                this.setPaginacaoBuscaCobrancasFornecedor(paginacao)
                this.buscarCobrancas()
            },
            eventoPagar(cobranca) {
                if (cobranca.tipoPagamento === 'BOLETO') {
                    window.open(cobranca.urlBoleto, '_blank');
                } else {
                    window.open(cobranca.urlFatura, '_blank');
                }
            },
            verificarUsuarioFornecedor() {
                if (this.$store.state.loki.user.type !== 'EXTERNO') {
                    this.$router.push({name: 'licitacaoBusca'})
                }
            },
            alterarPlano() {
                this.$router.push({name: 'planos'})
            }

        }
    }
</script>

<style scoped lang="stylus">

    .plano-faturas-header
        margin-bottom 10px
        display flex
        align-items center
        justify-content space-between

    .plano-faturas-info
        display flex
        align-items center
        justify-content space-between
        border 1px solid #ccc
        border-radius 5px
        padding 10px
        width 50%
        height 120px
        margin-right 20px

        .info-container
            display flex
            flex-direction column

            .label-info-content
                color #808080

            .bold-content
                font-weight bold
                color #717171

    .plano-faturas-cadastro
        display flex
        flex-direction column
        justify-content center
        border 1px solid #ccc
        border-radius 5px
        padding 10px
        width 50%
        height 120px
        margin-left 20px

    .label-plano-faturas
        font-weight bold
        font-size 18px
        color #717171

    .label-cadastro-content
        color #3A6861

    .btn-alterar-plano-faturas
        color #909090 !important
        border 1px solid #ccc !important
        border-radius 5px

    .historico-plano-faturas
        border 1px solid #ccc
        border-radius 5px
        padding-top 10px

</style>